import ComponentBase from 'components/_base/ComponentBase';
import jQuery from 'jquery';
import _ from 'underscore';

export default ComponentBase.extend(
  /**
   * @lends core.components.MessageControl.prototype
   */
  {
    template: require('./messageControl.hbs'),
    componentClass: 'message-control',
    events: {
      'click .lmm-icon-close': '_close'
    },
    /**
     * @class MessageControl
     * @classdesc Creates the view of the errors
     * @memberof core.components
     * @extends core.components.ComponentBase
     * @param {object} [options={}] The options provided by json
     */
    constructor(options = {}) {
      this.widget = options.widget;
      this.position = options.position;
      this.collection = this.widget.messageControl;
      ComponentBase.prototype.constructor.call(this, options);
    },

    /**
     * Initialize the component. This overrides ComponentBase initialize in order to create the components for journey planner
     * @param {object} - The options provided by json
     */
    initialize(config) {
      ComponentBase.prototype.initialize.call(this, config);
      this.listenTo(this.collection, 'add', this._render);
      this.listenTo(this.collection, 'remove', this._hideMessage);
    },

    _render() {
      this._clear();
      this.collection.forEach((item) => {
        this._createMessage(item.attributes);
      });
    },

    _createMessage(config) {
      let messageEl = this._createMessageEl(config);
      this.$el.append(messageEl);
      this._showMessage(config);
    },

    /**
     * Create the template of the message
     * @private
     * @param {object} config - The conf provided in json
     * @returns {String}
     */
    _createMessageEl(config) {
      let messageEl = jQuery(
        `<div id="${config.id}" class="lmm-message-control lmm-message lmm-${config.type}">
      <div class="lmm-icon lmm-icon-${config.type}"></div>
      <div class="lmm-message-text">${config.text}
      </div>
      <div class="lmm-icon lmm-icon-close"></div>
    </div>`
      );
      return messageEl;
    },

    /**
     * Set a timeout to the message
     * @private
     * @param {object} config - The conf provided in json
     */
    _showMessage(config) {
      this.$el.find(`#${config.id}`).show();
      if (_.isNumber(config.autohide)) {
        setTimeout(() => {
          this._hideMessage(config.id);
          this.collection.removeById(config.id);
        }, config.autohide);
      }
    },

    /**
     * Remove the message by model.
     * @param {object} messageControlModel - model to delete
     */
    _hideMessage(messageControlModel) {
      this.$el.find(`#${messageControlModel.id}`).remove();
    },

    /**
     * Close manually the message
     * @param {object} event - The event with the message id
     */
    _close(event) {
      let id = jQuery(event.target).parent().attr('id');
      this.collection.removeById(id);
    },

    /**
     * Close all messages
     */
    _clear() {
      this.collection.forEach((item) => {
        this.$el.find(`#${item.id}`).remove();
      });
    }

  });



// WEBPACK FOOTER //
// ./lmm-widget/src/components/messageControl/MessageControl.js